export default __webpack_public_path__ + "static/media/edit_white_1.0524b567.svg";